<template>
    <div id="content">
        <link rel="stylesheet" href="/themes/ito/css/parents.css?v=4" />
        <div class="container">
            <div class="card card-parents card-tutoring">
                <div class="card-body">
                    <div class="card-header">
                        <div class="card-title flex">{{$t('live_class')}}</div>
                        <div class="card-desc-right">
                            <div class="select-wrapper" style="display: inline-block;">
                                <select name="tutoring_filter" id="tutoring_filter" v-model="tutoring_filter" @change="filterTutoring" class="form-control" placeholder = "Filter">
                                    <option value="">{{$t('all')}}</option>
                                    <option value="1">{{$t('live_now')}}</option>
                                    <option value="2">{{$t('scheduled')}}</option>
                                    <option value="3">{{$t('finished')}}</option>
                                </select>
                            </div>
                        </div>
                    </div>     
                    <div class="card-content">
                        <div class="d-flex" style="margin-bottom: 12px">
                            <div class="description flex">{{$t('tutoring_desc')}}</div>
                            <div>
                                <img src="/themes/web/assets/images/icon-tutoring-help.svg" data-bs-toggle="modal" data-bs-target="#tutoringHelpModal" alt="">
                            </div>
                        </div>

                        <div class="report live-class-report">
                            <div :class="live_classes.length > 0?'report-1':'report-1 empty'">
                                <div class="recent-class nano">
                                    <div class="nano-content">
                                        <p>{{$t('recent_class')}}</p>
                                        <div class="class-list" v-if="live_classes.length > 0">
                                            <template v-for="(live_class, index) in live_classes">
                                                <live-class-item  :tutoring="live_class" @updateTutoring = "updateTutoring" />
                                            </template>

                                            <!--
                                            <div class="class-item">
                                                <div class="class-item-content">
                                                    <h4>Thứ 5 - 18/06/2022 - 09:00 đến 10:15</h4>

                                                     <div class="d-flex">
                                                        <div class="class-item-col-1">
                                                            <div class="desc"><b>Lớp học: </b> <span class="underline">Toán 3.10</span></div>
                                                            <div class="desc"><b>Môn: </b> <span class="underline">Toán 3</span></div>
                                                            <div class="desc"><b>Giáo viên: </b> <span class="underline">Nguyễn Thị Định</span></div>
                                            
                                                        </div>
                                                        <div class="class-item-col-2">
                                                            <button class="btn btn-join-class" style="padding: 8px 25px;  width: 180px">Vào lớp học</button>
                                                        </div>
                                                     </div>
                                                </div>
                                            </div>

                                            <div class="class-item blue">
                                                <div class="class-item-content">
                                                    <h4>Thứ 5 - 18/06/2022 - 09:00 đến 10:15 <span class="live-class-dot"></span><span class="live-class-text">Đang diễn ra</span></h4>

                                                    <div class="d-flex">
                                                        <div class="class-item-col-1">
                                                            <div class="desc"><b>Lớp học: </b> <span class="underline">Toán 3.10</span></div>
                                                            <div class="desc"><b>Môn: </b> <span class="underline">Toán 3</span></div>
                                                            <div class="desc"><b>Giáo viên: </b> <span class="underline">Nguyễn Thị Định</span></div>
                                                        </div>
                                                        <div class="class-item-col-2">
                                                            <button class="btn btn-register-class"  style="padding: 8px 25px;">Lớp sẽ mở trong 02:31:12</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>                                            

                                            <div class="class-item gray">
                                                <div class="class-item-content">
                                                    <h4>Thứ 5 - 18/06/2022 - 09:00 đến 10:15</h4>

                                                    <div class="d-flex">
                                                        <div class="class-item-col-1">
                                                            <div class="desc"><b>Lớp học: </b> <span class="underline">Toán 3.10</span></div>
                                                            <div class="desc"><b>Môn: </b> <span class="underline">Toán 3</span></div>
                                                            <div class="desc"><b>Giáo viên: </b> <span class="underline">Nguyễn Thị Định</span></div>
                                                        </div>
                                                        <div class="class-item-col-2">
                                                            <button class="btn btn-class-finish"  style="padding: 8px 25px; width: 180px">Lớp đã kết thúc</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            -->

                                        </div>
                                        <div v-else>
                                            <div class="class-empty">{{$t('live_class_empty')}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="report-2">
                                <div class="calendar">
                                    <div class="calendar-body">
                                        <div class="calendar-days">
                                            <div class="calendar-header">
                                                <div class="calendar-header-title">{{month_label}}, {{year}}</div>
                                                <div class="calendar-header-tool">
                                                    <a class="calendar-prev" href="#" @click="prevDay">
                                                        <img
                                                                src="/themes/ito/images/icons/icon-calander-prev.svg"
                                                                alt=""
                                                        />
                                                    </a>
                                                    <a class="calendar-next" href="#" @click="nextDay">
                                                        <img
                                                                src="/themes/ito/images/icons/icon-calander-next.svg"
                                                                alt=""
                                                        />
                                                    </a>
                                                </div>
                                            </div>
                                            <div class="calendar-row calendar-row-1">
                                                <div class="calendar-col">{{$t('mon')}}</div>
                                                <div class="calendar-col">{{$t('tue')}}</div>
                                                <div class="calendar-col">{{$t('wed')}}</div>
                                                <div class="calendar-col">{{$t('thu')}}</div>
                                                <div class="calendar-col">{{$t('fri')}}</div>
                                                <div class="calendar-col">{{$t('sat')}}</div>
                                                <div class="calendar-col">{{$t('sun')}}</div>
                                            </div>
                                            <div class="calendar-row" v-for="(calander, index) in calanders">
                                                <template v-for="(day, index) in calander">
                                                    <div class="calendar-col"  v-if="day.day == ''">
                                                    </div>
                                                    <div class="calendar-col day day-active" :class="day_select == day.day? 'border1' : ''" v-else-if="day.current == true" @click="Test(day)">
                                                        <div class="text current-day">{{day.day}}</div>
                                                        <div v-for="(statuss,index) in tutorings"  v-if="formatDay(statuss.time_start)==day.day">                                                            
                                                            <!-- <div v-if="statuss.status==2" class="live-now"></div>
                                                            <div v-if="statuss.status==3" class="live-now"></div>
                                                            <div v-if="statuss.status==6" class="live-comming"></div>
                                                            <div v-if="statuss.status==7" class="live-comming"></div>
                                                            <div v-if="statuss.status==4" class="finished-class"></div> -->

                                                            <div v-if="statuss.status==2" class="live-now"></div>
                                                            <div v-if="statuss.status==1" class="live-comming"></div>
                                                            <div v-if="statuss.status==4" class="finished-class"></div>

                                                            <!-- <div v-if="statusOfDay==1" class="live-now"></div>
                                                            <div v-if="statusOfDay==2" class="live-comming"></div>
                                                            <div v-if="statusOfDay==3" class="finished-class"></div> -->
                                                        </div>
                                                    </div>
                                                    <div class="calendar-col day disable" v-else-if="day.disabled == true">
                                                        <div class="text">{{day.day}}</div>
                                                    </div>
                                                    <div class="calendar-col day" :class="day_select == day.day? 'border1' : ''" v-else="day.day != ''" @click="Test(day)">
                                                        <div class="text">{{day.day}}</div>
                                                        <div class="status" v-for="(statuss,index) in tutorings"  v-if="formatDay(statuss.time_start)==day.day"  >
                                                            
                                                            <div v-if="statuss.status==2" class="live-now"></div>
                                                            <div v-if="statuss.status==1" class="live-comming"></div>
                                                            <div v-if="statuss.status==4" class="finished-class"></div>
<!--                                                             
                                                            <div v-if="statusOfDay==1" class="live-now"></div>
                                                            <div v-if="statusOfDay==2" class="live-comming"></div>
                                                            <div v-if="statusOfDay==3" class="finished-class"></div> -->
                                                        </div>
                                                        <span class="calendar-ico yellow" v-if="day.subject == 'math'"></span>
                                                        <span class="calendar-ico ping" v-else-if="day.subject == 'science'"></span>
                                                        <span class="calendar-ico" v-else-if="day.subject == 'ge'"></span>
                                                        <span class="calendar-ico" v-else-if="day.subject == 'igs'"></span>
                                                    </div>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal modal-flex" id="tutoringHelpModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="formErrorModal" aria-hidden="true">
            <div class="modal-dialog" style="width: 207px; max-width: 207px;">
                <div class="modal-content">
                    <div class="modal-body">
                        <h4 class="title">{{$t('colour_explanation')}}</h4>
                        <div class="tutoring-help-modal">
                            <p><span class="c1"></span>{{$t('live_now_classes_2')}}</p>
                            <p><span class="c2"></span>{{$t('scheduled_classes')}}</p>
                            <p><span class="c5"></span>{{$t('finished_classes_2')}}</p>
                        </div>
                    </div>
                    <p type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></p>
                </div>
            </div>
        </div>

        <div class="modal fade modal-tutoring" id="tutoringDetailRegisterSuccessModal" tabindex="-1" role="dialog" aria-labelledby="registerModal" aria-hidden="true" data-backdrop="static" data-keyboard=false>
            <div class="modal-dialog modal-dialog-centered popup-main-1" role="document" style="width: 380px; text-align: center;">
                <div class="modal-content box-shadow-main">
                    <div class="d-flex">
                        <h4 class="title text-center" style="width: 100%; margin-left: 9px;">{{$t('registered_successfully')}}</h4>
                        <div class="close-popup" data-dismiss="modal"></div>
                    </div>

                    <div style="margin: 15px auto;"><img src="/themes/ito/images/get-rewarded.svg" alt=""></div>

                    <div v-if="subscribe_from">
                        {{$t('dont_forget_the_class_at')}} {{tutoring_result.time_start | convertUnitToTime('HH:mm, DD MMM, YYYY')}}.
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
    import axios from "axios";
    import { getClassess, getTutorings } from "../../models/live_class";
    import {convertSecondToText} from "../../utils/utils";
    import LiveClassItem from './LiveClassItem.vue';

    export default {
        name: "Tutoring",
        title: "Tutoring",
        components: { LiveClassItem },
        data() {
            const date = new Date();
            const year = date.getFullYear();
            const months = [
                this.$i18n.t('month_1'),
                this.$i18n.t('month_2'),
                this.$i18n.t('month_3'),
                this.$i18n.t('month_4'),
                this.$i18n.t('month_5'),
                this.$i18n.t('month_6'),
                this.$i18n.t('month_7'),
                this.$i18n.t('month_8'),
                this.$i18n.t('month_9'),
                this.$i18n.t('month_10'),
                this.$i18n.t('month_11'),
                this.$i18n.t('month_12')
            ];
            const month = date.getMonth() + 1;
            const month_label = months[month - 1];
            const calanders = this.getCalanders(month, year);
            return {
                tutorings: [],
                tutoringsOfDay: [],
                live_classes: [],
                year: year,
                months: months,
                month: month,
                month_label: month_label,
                calanders: calanders,
                subscribe_days: [],
                subscribe_from: '',
                day_select: '',
                tutoring_filter: '',
                tutoring_result: null,    
                listStatus : [],
                statusOfDay : 4,
            };
        },
        computed: {
            user_info() {
                return this.$store.state.user_info;
            },
        },
        created() {
            this.$store.commit("setMenuActive", "liveclass");
            this.fetch();
        },
        methods: {
            async Test(day) {
                const that = this;
                const live_classes = [];
                that.day_select = day.day;
                that.tutorings.forEach(function(tutoring) {
                    if(that.showTutoringItem(tutoring)){
                        if(that.formatDay(tutoring.time_start) == that.day_select){
                            live_classes.push(tutoring);
                        }
                    }
                })
                that.live_classes = live_classes;    
                that.$forceUpdate()
            },
            formatDay(timestamp) {
                var date = new Date(timestamp * 1000);
                var day = date.getDate();
                return day;
            },
            formatTime(time)
            {
                var date =new Date(time*1000);
                var time=date.getTime();
                return time;
            },
            async getListTutoring(month, year){
                const that = this;

                await axios.all([getTutorings({
                    month: that.month,
                    year: that.year
                })]).then(
                    axios.spread((response) => {
                        that.$store.commit("setLoading", false);
                        if (response.data.code != 0) {
                            that.tutorings = [];
                            return;
                        }
                        try {
                            that.tutorings = response.data.results?response.data.results.class : [];
                            that.live_classes = response.data.results?response.data.results.class : [];
            
                            console.log("live_classes: ", that.live_classes);

                            //Get class current day
                            const date = new Date();
                            let day = date.getDate();
                            const live_classes = [];

                            that.day_select = that.day_select ? that.day_select : day;
                            that.tutorings.forEach(function(tutoring) {
                                if(that.showTutoringItem(tutoring)){
                                    if(that.formatDay(tutoring.time_start) == that.day_select){
                                        live_classes.push(tutoring);
                                    }
                                }
                            })
                            that.live_classes = live_classes;    
                            that.tutoringsOfDay = live_classes;

                            live_classes.forEach(e => {
                                this.listStatus.push(e.status)
                            })
                            // if(this.listStatus.includes(2)){
                            //     this.statusOfDay = 1
                            // }else if(this.listStatus.includes(1)){
                            //     this.statusOfDay = 2
                            // }else{
                            //     this.statusOfDay = 3
                            // }

                            // this.$store.commit("setFilterClass", that.tutoring_filter);

                            that.$forceUpdate()
                            //end

                        } catch (error) {
                            console.error(error);
                        }

                        that.calanders.forEach(function(calander) {
                            calander.forEach(function(day) {
                                if (day.disabled == false) {
                                    day.subject = that.getSubject(day.day)
                                }
                            })
                        })
                        that.$nextTick(function() {
                            // initNanoScroller();
                        });
                    })
                );
            },

            fetch() {
                this.getListTutoring(this.month, this.year);
            },
            showTutoringItem(tutoring){
                if(this.tutoring_filter == ''){
                    return true;
                }

                if(this.tutoring_filter == '1' && (tutoring.status == 2)){
                    return true;
                } 
                
                if(this.tutoring_filter == '2' && (tutoring.status == 1)){
                    return true;
                }

                if(this.tutoring_filter == '3' && tutoring.status == 4){
                    return true;
                }

                return false;
            },      
            filterTutoringWithDay(day){
                console.log(day)
            },
            filterTutoring(e){
                const that = this;
                const live_classes = [];


                that.day_select = that.day_select ? that.day_select : day;
                that.tutorings.forEach(function(tutoring) {
                    if(that.showTutoringItem(tutoring)){
                        if(that.formatDay(tutoring.time_start) == that.day_select){
                            live_classes.push(tutoring);
                        }
                    }
                })

                that.live_classes = live_classes;    
            },                  
            updateTutoring(action, tutoring, response){
                tutoring.status = response.status;

                this.subscribe_from = tutoring.subscribe_from;

                this.tutoring_result = tutoring;

                if(action == 'subscribe'){
                    $('#tutoringDetailRegisterSuccessModal').modal();
                }
            },
            convertUnitToTime(time, format = 'DD MMM, YYYY HH:mm:ss') {
                if (time) {
                    return moment.unix(time).format(format)
                }
                return '';
            },
            prevDay(e) {
                const that = this;
                this.$store.commit("setLoading", true);
                if (this.month == 1) {
                    this.month = 12;
                    this.year = this.year - 1;
                } else {
                    this.month = this.month - 1;
                }
                this.month_label = this.months[this.month - 1];

                this.calanders = this.getCalanders(this.month, this.year);

                this.getListTutoring(this.month, this.year);

                e.preventDefault();
            },
            nextDay(e) {
                const that = this;
                this.$store.commit("setLoading", true);
                if (this.month == 12) {
                    this.month = 1;
                    this.year = this.year + 1;
                } else {
                    this.month = this.month + 1;
                }
                this.month_label = this.months[this.month - 1];

                this.calanders = this.getCalanders(this.month, this.year);

                this.getListTutoring(this.month, this.year);

                e.preventDefault();
            },
            chunks(array, size) {
                var results = [];
                while (array.length) {
                    results.push(array.splice(0, size));
                }
                return results;
            },
            getCalanders(month, year) {
                const that = this;
                const date = new Date();
                const data = [];
                const firstDay = this.getFirstDayInMonth(month, year);
                const lastDay = this.getDaysInMonth(month, year);
                const days = ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'];
                const current_date = date.getDate();
                const current_month = date.getMonth() + 1;
                const current_year = date.getFullYear();

                const lastDayMonthBefore = this.getDaysInMonth(month - 1, year);
                for (var i = firstDay - 1; i >= 1; i--) {
                    data.push({
                        day: lastDayMonthBefore - i,
                        disabled: true
                    });
                }
                for (var i = 1; i <= lastDay; i++) {
                    let disabled = false;
                    let current = false;
                    if (current_year < year || (current_year == year && current_month < month) || (current_year == year && current_month == month && current_date < i)) {
                        //disabled = true;
                    }
                    if (current_year == year && current_month == month && current_date == i) {
                        current = true;
                    }
                    const d = new Date(year, month - 1, i).getDay();
                    data.push({
                        day: i,
                        label: days[d - 1],
                        disabled: disabled,
                        current: current,
                    });
                }
                const lastDays = Math.ceil(data.length / 7) * 7 - data.length;
                for (var i = 1; i <= lastDays; i++) {
                    data.push({
                        day: i,
                        disabled: true
                    });
                }
                return this.chunks(data, 7);
            },
            getSubject(day) {
                const that = this;
                let subject = "";

                that.tutorings.forEach(function(tutoring) {
                    const s_day = that.convertUnitToTime(tutoring.subscribe_from, 'DD');
                    if (s_day == day) {
                        subject = tutoring.subject;
                    }
                });

                return subject;
            },

            getDaysInMonth(month, year) {
                // Here January is 1 based
                // Day 0 is the last day in the previous month
                return new Date(year, month, 0).getDate();
                // Here January is 0 based
                // return new Date(year, month+1, 0).getDate();
            },

            getFirstDayInMonth(month, year) {
                const day = new Date(year, month - 1, 1).getDay();

                switch(day){
                    case 0:
                        return 7;
                    case 1:
                        return 1;
                    case 2:
                        return 2;
                    case 3:
                        return 3;
                    case 4:
                        return 4;
                    case 5:
                        return 5;
                    case 6:
                        return 6;
                    default:
                        return 0;
                }
            },
        },
    };
</script>
<style scoped>
    .finished-class {
        background: #979797;
        margin-bottom: 1rem;
        margin-top: 40px;
        width: 4px;
        height: 4px;
        right: 18px;
        line-height: 20px;
        border-radius: 100%;
        position: absolute;
        top: -12px;
        padding: 0;
        z-index: 1;
    }
    .live-comming{
        background: #00A3FF;
        margin-bottom: 1rem;
        margin-top: 40px;
        width: 4px;
        height: 4px;
        right: 18px;
        line-height: 20px;
        border-radius: 100%;
        position: absolute;
        top: -12px;
        padding: 0;
        z-index: 1;
    }
    .not-registed{
        background: #F0C020;
        margin-bottom: 1rem;
        margin-top: 40px;
        width: 4px;
        height: 4px;
        right: 18px;
        line-height: 20px;
        border-radius: 100%;
        position: absolute;
        top: -12px;
        padding: 0;
        z-index: 2;
    }
    .full-slots{
        background:#FA450F;
        margin-bottom: 1rem;
        margin-top: 40px;
        width: 4px;
        height: 4px;
        right: 18px;
        line-height: 20px;
        border-radius: 100%;
        position: absolute;
        top: -12px;
        padding: 0;
    }
    .registed-class{
        background: #00A3FF;
        margin-bottom: 1rem;
        margin-top: 40px;
        width: 4px;
        height: 4px;
        right: 18px;
        line-height: 20px;
        border-radius: 100%;
        position: absolute;
        top: -12px;
        padding: 0;
        z-index:3;
    }
    .live-now {
        background: #98C93C;
        margin-bottom: 1rem;
        margin-top: 40px;
        width: 4px;
        height: 4px;
        right: 18px;
        line-height: 20px;
        border-radius: 100%;
        position: absolute;
        top: -12px;
        padding: 0;
        z-index: 4;
    }
    .card-tutoring .calendar-row>.calendar-col.day-active{
        color:#00A3FF;
    }
    .card-tutoring .calendar-row>.calendar-col.border1{
        border: 1px solid #00A3FF ;
        border-radius: 4px;
    }




    /* .card-tutoring .nano>.nano-pane {
        width: 5px;
        right: -9px !important;
    } */
    .live-class-report{
        display: flex;
        justify-content: space-between;

    }
    .live-class-report .report-1{
        background: #EEEEEE;
        border-radius: 4px;
        margin-right: 23px;
        padding: 12px;
        height: 100%;
    }
    .live-class-report .nano-content>p{
        color: #000000;
        font-weight: 700;
        font-size: 14px;
    }
    .card-tutoring .card-content .description{
        padding-bottom: 0;
        margin-bottom: 0;
        border: none;
    }

    .card-tutoring .card-content{
        background-color: unset;
        padding: 25px 30px 30px;
    }

    .card-tutoring .card-header{
        display: flex;
        justify-content: space-between;
        background: #FFE39B;
        box-shadow: inset 0px 2px 0px rgba(255, 255, 255, 0.5);
        border-radius: 8px 8px 0px 0px;
        padding: 12px 30px;
        align-items: center;
        border: none;
    }
    .card-tutoring .card-header .card-title{
        color: #171717;
        font-weight: 700;
        font-size: 20px;
        margin: 0;
    }
    .card-tutoring .card-body{
        padding: 0;
    }

    .card-tutoring .class-list{
        padding: 0;
    }
    .card-tutoring .class-list>p{
        color: #000000;
        font-weight: 700;
        font-size: 14px;
        margin-bottom: 12px;
    }
    .current-day{
        font-weight: 800;
        font-size: 12px;
        color: #43ABFF;
    }
    #tutoringHelpModal .title{
        font-size: 16px;
        color: #000000;
        font-weight: 700;
    }
    #tutoringHelpModal .modal-body{
        padding: 15px;
    }
    #tutoringHelpModal .btn-close{
        width: 18px;
        height: 18px;
        position: absolute;
        top: 10px;
        right: 10px;
        cursor: pointer;
    }
    .class-empty{
        color: #000000;
        font-size: 14px;
        font-weight: 700;
        position: absolute;
        text-align: center;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
</style>
